<template>
  <div>
    <div class="header-content">
      <div style="text-align: center;margin-top: 20px;">
        <span class="dorm-text">西航后勤充值</span>
      </div>
      <div class="mesage">目前仅开放金堂校区 <span style="font-weight:500">电费充值</span> 功能</div>
    </div>
    <div class="fee-content">
    </div>
    <div style="text-align: center;margin-top: 100px;">
      <button class="recharge-btn" @click="goLogin">登录</button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import weui from 'weui.js'
import parseQueryString from 'ulia/lib/string/parseQueryString'
export default {
  name: 'container',
  computed: mapState({
    dormName: state => state.user.currentUser.dormName,
    userName: state => state.user.currentUser.userName,
    currentUser: state => state.user.currentUser
  }),
  async created() {
    const queryObj = parseQueryString(location.search)
    console.log(this.$router)
    if(queryObj.code){
        var loadingEl = weui.loading('登录中');
        let resp = await this.$store.dispatch({type: 'user/login', data: {code: queryObj.code}})
        loadingEl.hide(() => {
            if (!resp.name || !resp.room) {
                this.$router.replace({path: "mine"})
            }else{
                this.$router.replace({path: "recharge"})
            }
        })
    }
  },
  methods: {
      goLogin() { 
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6307ee1d939103cd&redirect_uri="+encodeURIComponent("http://energy.fanmeizhijia.com/login")+"&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
      }
  }
}
</script>

<style scoped>
  .header-content{
    background: #4953cf;
    border-radius: 0px 0px 20px 20px;
    min-height: 220px;
    color: white;
    padding: 30px;
  }
  .header-content span{
    font-weight: 600;
  }
  .dorm-text{
    font-size: 30px;
  }
  .dorm-mesage{
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    font-weight:600;
  }
  .mesage{
    text-align: center;
    font-size: 10px;
    margin-top: 20px;
  }
  .project{
    margin-top: 30px;
    background: white;
    color: #000;
    border-radius: 20px;
    text-align: center;
  }
  .project-main-text{
    color: #4b52aa;
    font-size: 18px;
    font-weight: 500;
    height: 70px;
    line-height: 70px;
  }
  .fee-content{
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 36px;
  }
  .fee-content-1{
    margin-top: 40px;
  }
  .fee-content-1 input{
    height: 40px;
    width: 80%;
    font-size: 35px;
    text-align: right;
  }
  .recharge-btn{
    height: 40px;
    width: 290px;
    background: #363fa3;
    color: white;
    font-weight: 500;
    border-radius: 20px;
    font-size: 18px;
  }
  .active{
    background: #f1f1f1;
  }
</style>